import { ACADEMIC_CALENDAR_2026 } from '../data/academicCalendar2026'

const DAY_MS = 1000 * 60 * 60 * 24;

const SEMESTER_STARTS = ACADEMIC_CALENDAR_2026
  .filter(event => event.category === 'semester_start' && /^\d학기$/.test(event.term ?? ''))
  .map(event => ({ term: event.term, date: event.startDate }))
  .sort((a, b) => a.date.localeCompare(b.date))

const VACATION_STARTS = ACADEMIC_CALENDAR_2026
  .filter(event => event.category === 'vacation')
  .map(event => ({ term: event.term, date: event.startDate }))

function toLocalDateOnly(value) {
  const date = value instanceof Date ? value : new Date(value);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function parseLocalDate(dateString) {
  const [year, month, day] = dateString.split("-").map(Number);
  return new Date(year, month - 1, day);
}

function getSemesterStartForDate(date) {
  const target = toLocalDateOnly(date)
  return [...SEMESTER_STARTS].reverse().find(({ date }) => target >= parseLocalDate(date))
}

function getNextSemesterStart(date) {
  const target = toLocalDateOnly(date)
  return SEMESTER_STARTS.find(({ date }) => target < parseLocalDate(date))
}

function daysBetween(start, target) {
  return Math.floor((target - start) / DAY_MS)
}

function semesterWeekFromStart(start, target) {
  const diffDays = daysBetween(start, target)
  if (diffDays < 0) return null

  // The opening week runs through Sunday; the following Monday starts week 2.
  const firstMondayDiff = (8 - start.getDay()) % 7
  const week = diffDays < firstMondayDiff
    ? 1
    : Math.floor((diffDays - firstMondayDiff) / 7) + 2
  return week > 16 ? null : week
}

export function getCurrentSemesterWeek(date = new Date()) {
  const target = toLocalDateOnly(date);
  const semesterStart = getSemesterStartForDate(target)
  if (!semesterStart) return null
  return semesterWeekFromStart(parseLocalDate(semesterStart.date), target)
}

export function formatSemesterWeek(date = new Date()) {
  const target = toLocalDateOnly(date);
  const nextSemester = getNextSemesterStart(target)
  if (nextSemester) {
    const daysUntilStart = daysBetween(target, parseLocalDate(nextSemester.date))
    return daysUntilStart > 0 ? `개강 D-${daysUntilStart}` : '1주차'
  }

  const week = getCurrentSemesterWeek(date);
  if (week === null) {
    return '학기 종료';
  }
  return `${week}주차`;
}

// 개강 전(diff < 0)은 학기 종료가 아니라 "아직 시작 안 함" 상태이므로 제외한다.
export function isSemesterOver(date = new Date()) {
  const start = parseLocalDate(SEMESTER_STARTS[0].date);
  const target = toLocalDateOnly(date);
  if (target < start) return false;
  const nextSemesterStart = parseLocalDate(SEMESTER_STARTS[1].date);
  const summerVacationStart = parseLocalDate(VACATION_STARTS.find(({ term }) => term === '하계').date);
  const winterVacationStart = parseLocalDate(VACATION_STARTS.find(({ term }) => term === '동계').date);
  // 셔틀 운행 상태는 주차 계산이 아니라 공식 방학 시작일을 기준으로 한다.
  if (target < nextSemesterStart) return target >= summerVacationStart;
  return target >= winterVacationStart;
}

export function isBeforeSecondSemesterStart(date = new Date()) {
  return toLocalDateOnly(date) < parseLocalDate(SEMESTER_STARTS[1].date);
}
